/* eslint-disable */

/**
 *
 * @param $httpProvider
 */
export function httpProvider($httpProvider) {

	"ngInject";

	let unauthorizedInterceptor = ($q, $injector) => {
		return {
			responseError: (response) => {
				if (response.status === 401 && !response.config.ignore401) {
					return $injector.get("$auth").logout();
				}
				return $q.reject(response);
			}
		};
	};

	let forbiddenInterceptor = ($q, $injector) => {
		"ngInject";
		return {
			responseError: (response) => {
				if (response.status === 403) {
					if (!response.config.url.includes('remove-bg') && !response.config.url.includes('replicate-remove-bg')) {
						$injector.get("$state").go("forbidden");
					}
				}
				return $q.reject(response);
			}
		};
	};

	let notfoundInterceptor = ($q, $injector) => {
		return {
			responseError: (response) => {
				if (response.status === 404) {
					$injector.get("$state").go("orders");
				}
				return $q.reject(response);
			}
		};
	};

	$httpProvider.interceptors.push(
		unauthorizedInterceptor,
		forbiddenInterceptor
	);

	if (window.GaeMiniProfiler) {
		let gaeMiniProfilerInterceptor = ($q, $injector) => {
			return {
				response: (response) => {
					// var xhr = response;
					var requestId = response.headers("X-MiniProfiler-Id");
					if (requestId) {
						var queryString = response.headers("X-MiniProfiler-QS");
						GaeMiniProfiler.fetch(requestId, queryString);
					}
					return response;
				}
			};
		};
		$httpProvider.interceptors.push(gaeMiniProfilerInterceptor);
	}

}



// WEBPACK FOOTER //
// ./sources/config/httpProvider.config.js